export default __webpack_public_path__ + "images/house-img-not-available.png";